import { render, staticRenderFns } from "./TextFilter.vue?vue&type=template&id=0a807ca4&scoped=true&"
import script from "./TextFilter.vue?vue&type=script&lang=js&"
export * from "./TextFilter.vue?vue&type=script&lang=js&"
import style0 from "./TextFilter.vue?vue&type=style&index=0&id=0a807ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a807ca4",
  null
  
)

export default component.exports